(function () {
  function slugify(text) {
    return text
      .toString()
      .trim()
      .toLowerCase()
      .replace(/&/g, ' and ')
      .replace(/[^a-z0-9\u4e00-\u9fa5]+/g, '-')
      .replace(/^-+|-+$/g, '') || 'section';
  }

  function buildToc(articleRoot) {
    var rte = articleRoot.querySelector('[data-pb-article-rte]');
    if (!rte) return;

    var headings = Array.prototype.slice.call(rte.querySelectorAll('h2'));
    var tocContainers = Array.prototype.slice.call(articleRoot.querySelectorAll('[data-pb-toc-links]'));
    var tocWrappers = Array.prototype.slice.call(articleRoot.querySelectorAll('[data-pb-desktop-toc], [data-pb-mobile-toc]'));
    var tocCounts = Array.prototype.slice.call(articleRoot.querySelectorAll('[data-pb-toc-count]'));

    if (headings.length < 2) {
      tocWrappers.forEach(function (wrapper) {
        wrapper.classList.add('is-hidden');
      });
      return;
    }

    var usedIds = {};

    headings.forEach(function (heading) {
      if (!heading.id) {
        var baseId = slugify(heading.textContent);
        var id = baseId;
        var index = 2;

        while (usedIds[id] || document.getElementById(id)) {
          id = baseId + '-' + index;
          index += 1;
        }

        heading.id = id;
      }
      usedIds[heading.id] = true;
    });

    tocCounts.forEach(function (count) {
      count.textContent = headings.length + ' sections';
    });

    tocContainers.forEach(function (container) {
      container.innerHTML = '';
      headings.forEach(function (heading) {
        var link = document.createElement('a');
        link.href = '#' + heading.id;
        link.textContent = heading.textContent.trim();
        container.appendChild(link);
      });
    });
  }

  function initMobileToc(articleRoot) {
    if (articleRoot.dataset.pbMobileTocReady === 'true') return;

    var mobileToc = articleRoot.querySelector('[data-pb-mobile-toc]');
    if (!mobileToc) return;

    articleRoot.dataset.pbMobileTocReady = 'true';

    mobileToc.addEventListener('click', function (event) {
      var link = event.target && event.target.closest ? event.target.closest('a[href^="#"]') : null;
      if (!link) return;

      if (mobileToc.tagName && mobileToc.tagName.toLowerCase() === 'details') {
        window.setTimeout(function () {
          mobileToc.open = false;
        }, 80);
      }
    });
  }


  function enhanceTables(articleRoot) {
    var rte = articleRoot.querySelector('[data-pb-article-rte]');
    if (!rte) return;

    var tables = Array.prototype.slice.call(rte.querySelectorAll('table'));
    tables.forEach(function (table) {
      if (table.dataset.pbTableReady === 'true' || table.closest('.pb-table-scroll')) return;

      table.dataset.pbTableReady = 'true';

      var wrapper = document.createElement('div');
      wrapper.className = 'pb-table-scroll';
      wrapper.setAttribute('tabindex', '0');
      wrapper.setAttribute('role', 'region');
      wrapper.setAttribute('aria-label', 'Scrollable comparison table');

      table.parentNode.insertBefore(wrapper, table);
      wrapper.appendChild(table);
    });
  }

  function enhanceFaq(articleRoot) {
    var rte = articleRoot.querySelector('[data-pb-article-rte]');
    if (!rte) return;

    var faqHeadings = Array.prototype.slice.call(rte.querySelectorAll('h2')).filter(function (heading) {
      var text = heading.textContent.trim().toLowerCase();
      return text.indexOf('faq') !== -1 || text.indexOf('frequently asked') !== -1;
    });

    faqHeadings.forEach(function (heading) {
      if (heading.dataset.pbFaqReady === 'true') return;

      var questions = [];
      var node = heading.nextElementSibling;

      while (node && node.tagName && node.tagName.toLowerCase() !== 'h2') {
        var tag = node.tagName.toLowerCase();
        if (tag === 'h3' || tag === 'h4') {
          questions.push(node);
        }
        node = node.nextElementSibling;
      }

      if (!questions.length) return;

      heading.dataset.pbFaqReady = 'true';
      heading.classList.add('pb-faq-heading');

      var faqList = document.createElement('div');
      faqList.className = 'pb-faq-list';
      questions[0].parentNode.insertBefore(faqList, questions[0]);

      questions.forEach(function (question, index) {
        if (!question.parentNode) return;

        var details = document.createElement('details');
        details.className = 'pb-faq-item';
        if (index === 0) details.open = true;

        var summary = document.createElement('summary');
        summary.textContent = question.textContent.trim();
        details.appendChild(summary);

        var body = document.createElement('div');
        body.className = 'pb-faq-item__body';

        var next = question.nextElementSibling;
        question.parentNode.removeChild(question);

        while (next && next.tagName) {
          var tag = next.tagName.toLowerCase();
          if (tag === 'h2' || tag === 'h3' || tag === 'h4') break;

          var current = next;
          next = next.nextElementSibling;
          body.appendChild(current);
        }

        details.appendChild(body);
        faqList.appendChild(details);
      });
    });
  }

  function initTocActive(articleRoot) {
    if (articleRoot.dataset.pbTocActiveReady === 'true') return;

    var rte = articleRoot.querySelector('[data-pb-article-rte]');
    if (!rte) return;

    var headings = Array.prototype.slice.call(rte.querySelectorAll('h2[id]'));
    var links = Array.prototype.slice.call(articleRoot.querySelectorAll('[data-pb-toc-links] a[href^="#"]'));
    if (!headings.length || !links.length) return;

    articleRoot.dataset.pbTocActiveReady = 'true';

    function setActive(activeId) {
      links.forEach(function (link) {
        var linkId = decodeURIComponent(link.getAttribute('href').replace('#', ''));
        link.classList.toggle('is-active', linkId === activeId);
      });
    }

    function updateActiveLink() {
      var activeHeading = headings[0];

      headings.forEach(function (heading) {
        if (heading.getBoundingClientRect().top <= 125) {
          activeHeading = heading;
        }
      });

      if (activeHeading) {
        setActive(activeHeading.id);
      }
    }

    updateActiveLink();
    window.addEventListener('scroll', updateActiveLink, { passive: true });
    window.addEventListener('resize', updateActiveLink);
  }

  function copyShareUrl(url) {
    if (navigator.clipboard && navigator.clipboard.writeText) {
      return navigator.clipboard.writeText(url);
    }

    return new Promise(function (resolve, reject) {
      var input = document.createElement('textarea');
      input.value = url;
      input.setAttribute('readonly', '');
      input.style.position = 'fixed';
      input.style.top = '-9999px';
      document.body.appendChild(input);
      input.select();

      try {
        document.execCommand('copy');
        document.body.removeChild(input);
        resolve();
      } catch (error) {
        document.body.removeChild(input);
        reject(error);
      }
    });
  }

  function setTemporaryLabel(button) {
    var label = button.querySelector('[data-pb-copy-label]') || button;
    var defaultLabel = button.getAttribute('data-copy-default') || label.textContent.trim();
    var successLabel = button.getAttribute('data-copy-success') || 'Copied';

    label.textContent = successLabel;
    button.setAttribute('aria-label', successLabel);
    if (button.hasAttribute('title')) button.setAttribute('title', successLabel);
    window.setTimeout(function () {
      label.textContent = defaultLabel;
      button.setAttribute('aria-label', defaultLabel);
      if (button.hasAttribute('title')) button.setAttribute('title', defaultLabel);
    }, 1600);
  }

  function initShareButtons(articleRoot) {
    if (articleRoot.dataset.pbShareReady === 'true') return;

    var shareGroups = Array.prototype.slice.call(articleRoot.querySelectorAll('[data-pb-share]'));
    if (!shareGroups.length) return;

    articleRoot.dataset.pbShareReady = 'true';

    shareGroups.forEach(function (group) {
      var shareUrl = group.getAttribute('data-share-url') || window.location.href;
      var shareTitle = group.getAttribute('data-share-title') || document.title;
      var nativeButtons = Array.prototype.slice.call(group.querySelectorAll('[data-pb-native-share]'));
      var copyButtons = Array.prototype.slice.call(group.querySelectorAll('[data-pb-copy-link]'));

      nativeButtons.forEach(function (button) {
        if (!navigator.share && button.hasAttribute('data-pb-hide-without-native')) {
          button.hidden = true;
          return;
        }

        button.addEventListener('click', function () {
          if (navigator.share) {
            navigator.share({ title: shareTitle, url: shareUrl }).catch(function () {});
            return;
          }

          copyShareUrl(shareUrl).then(function () {
            setTemporaryLabel(button);
          }).catch(function () {});
        });
      });

      copyButtons.forEach(function (button) {
        button.addEventListener('click', function () {
          copyShareUrl(shareUrl).then(function () {
            setTemporaryLabel(button);
          }).catch(function () {});
        });
      });
    });
  }

  function initGuideDialogs(articleRoot) {
    if (articleRoot.dataset.pbDialogsReady === 'true') return;

    var shareDialog = articleRoot.querySelector('[data-pb-share-dialog]');
    var contactDialog = articleRoot.querySelector('[data-pb-contact-dialog]');
    var dialogs = [shareDialog, contactDialog].filter(Boolean);
    if (!dialogs.length) return;

    articleRoot.dataset.pbDialogsReady = 'true';

    function syncDialogState() {
      var hasOpenDialog = dialogs.some(function (dialog) {
        return dialog.open;
      });
      document.documentElement.classList.toggle('pb-guide-dialog-open', hasOpenDialog);
    }

    function openDialog(dialog) {
      if (!dialog || dialog.open) return;
      if (typeof dialog.showModal === 'function') {
        dialog.showModal();
      } else {
        dialog.setAttribute('open', '');
      }
      syncDialogState();
    }

    function closeDialog(dialog) {
      if (!dialog || !dialog.open) return;
      if (typeof dialog.close === 'function') {
        dialog.close();
      } else {
        dialog.removeAttribute('open');
        syncDialogState();
      }
    }

    Array.prototype.slice.call(articleRoot.querySelectorAll('[data-pb-open-share]')).forEach(function (button) {
      button.addEventListener('click', function () {
        openDialog(shareDialog);
      });
    });

    Array.prototype.slice.call(articleRoot.querySelectorAll('[data-pb-open-contact]')).forEach(function (button) {
      button.addEventListener('click', function () {
        openDialog(contactDialog);
      });
    });

    dialogs.forEach(function (dialog) {
      Array.prototype.slice.call(dialog.querySelectorAll('[data-pb-close-dialog]')).forEach(function (button) {
        button.addEventListener('click', function () {
          closeDialog(dialog);
        });
      });

      dialog.addEventListener('click', function (event) {
        if (event.target === dialog) closeDialog(dialog);
      });
      dialog.addEventListener('close', syncDialogState);
      dialog.addEventListener('cancel', syncDialogState);
    });

    if (contactDialog && contactDialog.querySelector('[data-pb-contact-success], [data-pb-contact-error]')) {
      openDialog(contactDialog);
    }
  }

  function initEquipmentCarousels(root) {
    var scope = root || document;
    var carousels = Array.prototype.slice.call(scope.querySelectorAll('[data-pb-equipment-carousel]'));

    carousels.forEach(function (carousel) {
      if (carousel.dataset.pbCarouselReady === 'true') return;

      var poster = carousel.closest('[data-pb-equipment-poster]');
      var track = carousel.querySelector('[data-pb-equipment-track]');
      var slides = Array.prototype.slice.call(carousel.querySelectorAll('[data-pb-equipment-slide]'));
      var dots = poster ? Array.prototype.slice.call(poster.querySelectorAll('[data-pb-equipment-dot]')) : [];

      if (!track || slides.length <= 1) return;

      carousel.dataset.pbCarouselReady = 'true';

      var index = 0;
      var intervalId = null;
      var isDragging = false;
      var startX = 0;
      var dragDelta = 0;
      var wasDragged = false;
      var suppressClick = false;

      function getGap() {
        var styles = window.getComputedStyle(track);
        var gap = parseFloat(styles.columnGap || styles.gap || 0);
        return Number.isNaN(gap) ? 0 : gap;
      }

      function getStepWidth() {
        var firstSlide = slides[0];
        if (!firstSlide) return carousel.getBoundingClientRect().width || 1;
        return firstSlide.getBoundingClientRect().width + getGap();
      }

      function getMaxIndex() {
        return Math.max(0, slides.length - 1);
      }

      function updateDots() {
        dots.forEach(function (dot, dotIndex) {
          dot.classList.toggle('is-active', dotIndex === index);
        });
      }

      function setTrackPosition(deltaPx, animate) {
        var stepWidth = getStepWidth();
        var offset = -(index * stepWidth) + (deltaPx || 0);
        track.style.transition = animate === false ? 'none' : 'transform .36s ease';
        track.style.transform = 'translate3d(' + offset + 'px, 0, 0)';
      }

      function goTo(nextIndex, animate) {
        var maxIndex = getMaxIndex();
        if (nextIndex < 0) {
          index = maxIndex;
        } else if (nextIndex > maxIndex) {
          index = 0;
        } else {
          index = nextIndex;
        }
        setTrackPosition(0, animate !== false);
        updateDots();
      }

      function start() {
        stop();
        intervalId = window.setInterval(function () {
          goTo(index + 1, true);
        }, 5000);
      }

      function stop() {
        if (intervalId) {
          window.clearInterval(intervalId);
          intervalId = null;
        }
      }

      function onPointerDown(event) {
        if (event.button !== undefined && event.button !== 0) return;

        // Let links and CTA buttons work normally.
        // Without this, pointer capture on the carousel can block navigation in some browsers/theme-preview contexts.
        if (event.target && event.target.closest && event.target.closest('a[href], button')) {
          return;
        }

        isDragging = true;
        wasDragged = false;
        suppressClick = false;
        dragDelta = 0;
        startX = event.clientX;
        stop();
        carousel.classList.add('is-dragging');
        setTrackPosition(0, false);
        if (carousel.setPointerCapture && event.pointerId !== undefined) {
          try { carousel.setPointerCapture(event.pointerId); } catch (error) {}
        }
      }

      function onPointerMove(event) {
        if (!isDragging) return;
        dragDelta = event.clientX - startX;
        if (Math.abs(dragDelta) > 6) {
          wasDragged = true;
          suppressClick = true;
        }
        setTrackPosition(dragDelta, false);
      }

      function onPointerUp(event) {
        if (!isDragging) return;
        isDragging = false;
        carousel.classList.remove('is-dragging');
        if (carousel.releasePointerCapture && event.pointerId !== undefined) {
          try { carousel.releasePointerCapture(event.pointerId); } catch (error) {}
        }

        var threshold = Math.min(80, Math.max(42, getStepWidth() * 0.18));

        if (dragDelta <= -threshold) {
          goTo(index + 1, true);
        } else if (dragDelta >= threshold) {
          goTo(index - 1, true);
        } else {
          goTo(index, true);
        }

        dragDelta = 0;
        start();

        if (suppressClick) {
          window.setTimeout(function () {
            suppressClick = false;
            wasDragged = false;
          }, 80);
        }
      }

      dots.forEach(function (dot) {
        dot.addEventListener('click', function () {
          var dotIndex = parseInt(dot.getAttribute('data-pb-equipment-dot'), 10);
          if (!Number.isNaN(dotIndex)) {
            goTo(dotIndex, true);
            start();
          }
        });
      });

      carousel.addEventListener('pointerdown', onPointerDown);
      carousel.addEventListener('pointermove', onPointerMove);
      carousel.addEventListener('pointerup', onPointerUp);
      carousel.addEventListener('pointercancel', onPointerUp);
      carousel.addEventListener('pointerleave', function (event) {
        if (isDragging) onPointerUp(event);
      });

      carousel.addEventListener('click', function (event) {
        if (event.target && event.target.closest && event.target.closest('a[href]') && !wasDragged) {
          return;
        }
        if (suppressClick || wasDragged) {
          event.preventDefault();
          event.stopPropagation();
        }
      }, true);

      if (poster) {
        poster.addEventListener('mouseenter', stop);
        poster.addEventListener('mouseleave', start);
        poster.addEventListener('focusin', stop);
        poster.addEventListener('focusout', start);
      }

      window.addEventListener('resize', function () {
        goTo(index, false);
      });

      goTo(0, false);
      start();
    });
  }

  function initArticleUX(root) {
    var scope = root || document;
    var articleRoots = Array.prototype.slice.call(scope.querySelectorAll('[data-pb-guide-article]'));

    if (scope.matches && scope.matches('[data-pb-guide-article]')) {
      articleRoots.unshift(scope);
    }

    articleRoots.forEach(function (articleRoot) {
      enhanceFaq(articleRoot);
      enhanceTables(articleRoot);
      buildToc(articleRoot);
      initMobileToc(articleRoot);
      initTocActive(articleRoot);
      initShareButtons(articleRoot);
      initGuideDialogs(articleRoot);
    });
  }

  document.addEventListener('DOMContentLoaded', function () {
    initArticleUX(document);
    initEquipmentCarousels(document);
  });

  document.addEventListener('shopify:section:load', function (event) {
    initArticleUX(event.target);
    initEquipmentCarousels(event.target);
  });
})();
